import { AccountSwitchOverlay } from "./account-switch-overlay";
import { useAccount } from "@/providers/account-provider";

export const AccountSwitchOverlayWrapper = () => {
    const { isSwitching } = useAccount();
    return <AccountSwitchOverlay isOpen={isSwitching} />;
};

